import { IAction } from '../../actions/types'

export default function transferActionProps(fromAction: IAction, toAction: IAction): IAction {
  if (null == toAction.mode) {
    toAction.mode = fromAction.mode
  }
  if (null == toAction.preview) {
    toAction.preview = fromAction.preview
  }
  if (null == toAction.action_url && fromAction.action === toAction.action) {
    toAction.action_url = fromAction.action_url
  }
  if (null == toAction.aytm_domain && fromAction.action === toAction.action) {
    toAction.aytm_domain = fromAction.aytm_domain
  }
  return toAction
}
